import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'userGroup'
    ]),

    isSuperAdmin () {
      return this.userGroup === 'SuperAdministrator'
    },

    isAdmin () {
      return this.userGroup === 'SuperAdministrator' || this.userGroup === 'Administrator'
    },

    isAgency () {
      return this.userGroup === 'Agentur'
    }
  }
}
